module.exports = __webpack_public_path__ + "static/media/sensable_17.e305cd56.gif";